import UploadScoreCardForm from './UploadScoreCardForm';

export default UploadScoreCardForm;



// WEBPACK FOOTER //
// ./src/features/score-card/components/upload-score-card-form/index.js